import React, {useState, useEffect} from "react";
import SectionBox from "../../elements/SectionBox/SectionBox";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";
import {callAPI, log} from "../../utils/utils";
import {useSnackbar} from "notistack";
import CampaignOverviewElement from "./CampaignOverviewElement";
import {useNavigate} from "react-router-dom";

const CampaignOverviewBox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [ campaigns, setCampaigns ] = useState(null);
  const [ targets, setTargets ] = useState(null);
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    reloadCampaigns();
  }, []);

  const reloadCampaigns = () => {
    setLoading(true);
    callAPI("campaigns/overview", "POST").then((data) => {
      setCampaigns(data.campaigns);
      setTargets(data.targets);
      setLoading(false);
    });
  }

  const addCampaign = () => {
    const newName = prompt(t("CampaignOverview.CreatePrompt"), t("CampaignOverview.CreateDefault"));

    if (newName) {
      callAPI("campaigns/create", "POST", {name: newName}).then(() => {
        enqueueSnackbar(t("CampaignOverview.CreateSuccess"), {variant:'success'});
        reloadCampaigns();
      }).catch(() => {
        enqueueSnackbar(t("CampaignOverview.CreateError"), {variant:'error'});
      });
    }
  }

  const removeCampaign = (hash) => {
    if (window.confirm(t("CampaignOverview.RemoveConfirm"))) {
      callAPI("campaigns/remove", "POST", {hash: hash}).then(() => {
        enqueueSnackbar(t("CampaignOverview.RemoveSuccess"), {variant: 'success'});
        reloadCampaigns();
      }).catch(() => {
        enqueueSnackbar(t("CampaignOverview.RemoveError"), {variant: 'error'});
      });
    }
  };

  const renameCampaign = (hash, currentName) => {
    const newName = prompt(t("CampaignOverview.RenamePrompt"), currentName);
    if (newName && newName !== currentName) {
      callAPI("campaigns/update", "POST", {hash: hash, name: newName}).then(() => {
        enqueueSnackbar(t("CampaignOverview.RenameSuccess"), {variant:'success'});
        reloadCampaigns();
      }).catch(() => {
        enqueueSnackbar(t("CampaignOverview.RenameError"), {variant:'error'});
      });
    }
  }

  const navigationToDetails = (hash) => {
    navigate("/campaigns/" + hash, { replace: true });
  };

  const campaignsHTML = !campaigns ? <></> : campaigns.map((item, index) => {
    return <CampaignOverviewElement index={index} key={item.hash} campaign={item} targets={targets} onRemove={removeCampaign} onDetails={navigationToDetails} onRename={renameCampaign} />;
  });

  log(campaignsHTML);


  return (
    <SectionBox loading={loading} headline={"CampaignOverview.Headline"} info={"CampaignOverview.InfoText"} width={1000}>
      <div className={'campaign-overview__box'}>
      { campaigns && <>{campaignsHTML}</> }
      </div>
      <div className={'campaign-overview__footer'}>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          working={loading}
          className="submit"
          onClick={addCampaign}
        >
          {t("CampaignOverview.AddCampaign")}
        </Button>
      </div>
    </SectionBox>
  );
}

export default CampaignOverviewBox;